module.exports = __webpack_public_path__ + "img/Element_extraction-4.e8aebbb2.jpg";